import {Model} from '@vuex-orm/core';
import UnitPlanActivity from "./UnitPlanActivity";

export default class UnitPlanActivityFile extends Model {
    static entity = 'unitplan_activity_files';

    static fields () {
        return {
            id: this.number(0),
            activity_id: this.number(null),
            path: this.string('/'),
            name: this.string(''),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            activity: this.belongsTo(UnitPlanActivity, 'activity_id'),
        };
    }
}
